export default {
  "pl": {
    "timestamp": {
      "labels": {
        "accepted": "Data akceptacji: {date}",
        "due": "Termin: {date}",
        "in": "Pozostały czas: {time}",
        "justNow": "W tej chwili",
        "noDeadline": "Nie wyznaczono terminu",
        "starts": "Początek: {date}",
        "today": "Dziś",
        "tomorrow": "Jutro",
        "uploaded": "Data przesłania: {date}",
        "yesterday": "Wczoraj"
      }
    }
  }
}
